export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20digital%20reading%20platform%20scene%2C%20multiple%20devices%20displaying%20colorful%20manga%20pages%20in%20vertical%20scroll%20mode%2C%20cozy%20modern%20interior%20with%20warm%20lighting%2C%20bookshelf%20background%20with%20manga%20volumes%2C%20orange%20and%20cream%20color%20palette%2C%20professional%20editorial%20photography%2C%20clean%20aesthetic&width=1200&height=900&seq=about-manga-platform&orientation=landscape"
                alt="亲亲漫画网 - 关于平台介绍"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">关于亲亲</h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">亲亲漫画网</strong>成立于2020年，是国内领先的<strong className="text-foreground-900">下拉式漫画阅读</strong>平台。我们致力于为漫友提供最流畅、最沉浸的在线阅读体验，让每一部漫画都能以最自然的方式呈现。
              </p>
              <p>
                平台汇聚<strong className="text-foreground-900">超过30000部</strong>日漫、韩漫资源，涵盖热血格斗、甜蜜恋爱、烧脑悬疑、爆笑喜剧、奇幻冒险等全品类题材。采用自主研发的下拉式阅读引擎，告别传统翻页的割裂感，让你像刷社交媒体一样轻松追漫。
              </p>
              <p>
                我们坚持<strong className="text-foreground-900">全站免费、无广告干扰</strong>的运营理念，每日更新50+部热门连载，确保漫友第一时间看到最新内容。亲亲漫画网不仅是阅读工具，更是一个让漫画爱好者交流、发现好作品的社区。
              </p>
            </div>
            <div className="flex flex-wrap gap-3 mt-6">
              <span className="px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium">日漫大全</span>
              <span className="px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 text-xs font-medium">韩漫精选</span>
              <span className="px-4 py-1.5 rounded-full bg-secondary-50 text-secondary-700 text-xs font-medium">下拉式阅读</span>
              <span className="px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium">免费追更</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}